/**
 * Reusable skeleton loaders for Phase 9 polish.
 * Uses the .skeleton class defined in index.css (cross-page shimmer).
 */

export function SkeletonBox({ className = "", ...rest }) {
  return <div className={`skeleton ${className}`} {...rest} />;
}

export function SkeletonCard() {
  return (
    <div className="rounded-3xl border-[3px] border-white/5 p-6 bg-[#141414]">
      <SkeletonBox className="h-4 w-24 mb-4" />
      <SkeletonBox className="h-8 w-full mb-3" />
      <SkeletonBox className="h-3 w-3/4 mb-2" />
      <SkeletonBox className="h-3 w-1/2" />
    </div>
  );
}

export function SkeletonRow() {
  return (
    <div className="flex items-center gap-3 py-3">
      <SkeletonBox className="w-10 h-10 rounded-full" />
      <div className="flex-1 space-y-2">
        <SkeletonBox className="h-3 w-1/3" />
        <SkeletonBox className="h-2.5 w-1/2" />
      </div>
    </div>
  );
}

export function SkeletonList({ count = 5 }) {
  return (
    <div className="divide-y divide-white/5">
      {Array.from({ length: count }).map((_, i) => <SkeletonRow key={i} />)}
    </div>
  );
}

export function SkeletonGrid({ count = 6, cols = "md:grid-cols-2 lg:grid-cols-3" }) {
  return (
    <div className={`grid gap-6 ${cols}`}>
      {Array.from({ length: count }).map((_, i) => <SkeletonCard key={i} />)}
    </div>
  );
}
